export default {
      id: "ic_menu_authors-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_menu_authors-usage",
      toString: function () {
        return this.url;
      }
    }